// extracted by mini-css-extract-plugin
export default {"component":"Main__component--lc-B4Lf2","widget":"Main__widget--lc-Fqwcx","sliderNavigationWidget":"Main__sliderNavigationWidget--lc-wjoWV"};